import React from 'react';
import {Row, Col} from 'react-bootstrap';
import PropTypes from 'prop-types';

// const NotImplementedYet = ({ message }) => {
//   return (
//     <div style={{ textAlign: 'center', marginTop: '20%' }}>
//       <h4>{message}</h4>
//       <br/>
//       <h1>Feature Not Implemented Yet</h1>
//       <p>This feature is not available at the moment. Please check back later.</p>
//     </div>
//   );
// };

const styles = {
  container: {
    textAlign: 'center',
    marginTop: '20%',
    background: 'linear-gradient(90deg, rgba(83,108,48,1) 0%, rgba(45,46,70,1) 25%, rgba(45,46,70,1) 100%)',
    color: 'white',
    padding: '20px',
    borderRadius: '10px',
  },
  colorwhite: {
    color: 'white',
  },
};

const NotImplementedYet = ({ message }) => {
  return (
    <Row>
      <Col lg={3}>
      </Col>
      <Col lg={6}>
        <div style={styles.container}>
          <h3 style={styles.colorwhite}>{message}</h3>
          <br />
          <h2 style={styles.colorwhite}>Feature Not Implemented Yet</h2>
          <p>This feature is not available at the moment. Please check back later.</p>
        </div>
      </Col>
    </Row>

  );
};

NotImplementedYet.propTypes = {
  message: PropTypes.string,
};


NotImplementedYet.defaultProps = {
  message: 'Feature not available',
};

export default NotImplementedYet;

// import React from 'react';

// const NotImplementedYet = () => {
//   return (
//     <div style={{ textAlign: 'center', marginTop: '20%' }}>
//       <h1>Feature Not Implemented Yet</h1>
//       <p>This feature is not available at the moment. Please check back later.</p>
//     </div>
//   );
// };

// export default NotImplementedYet;